import React, { useState } from 'react';
import style from './StockDetails.module.css';
import IncomeStatementChart from './IncomeStatementChart';
import IncomeStatementTable from './IncomeStatementTable';
import TabButtons from '../TabButtons/TabButtons';
import BalanceSheetChart from './BalanceSheetChart';
import BalanceSheetTable from './BalanceSheetTable';
import useIncomeStatements from '../../hooks/useIncomeStatements';

const StockDetails = ({ stock, hideDetails }) => {
  const [activePeriod, setActivePeriod] = useState(hideDetails ? 'annual' : 'quarterly');
  const [activeTab, setActiveTab] = useState('income');
  const { incomeStatements } = useIncomeStatements(stock.id, activePeriod);

  if (!incomeStatements || !incomeStatements.history || incomeStatements.history.length === 0) return null;

  return (
    <div>
      { !hideDetails && (
        <div className={style.header}>
          <div>
            <TabButtons variant="title">
              <TabButtons.Tab onClick={() => setActiveTab('income')} active={activeTab === 'income'}>Revenue & Income</TabButtons.Tab>
              <TabButtons.Tab onClick={() => setActiveTab('balance')} active={activeTab === 'balance'}>Balance Sheet</TabButtons.Tab>
            </TabButtons>
          </div>

          {activeTab === 'income' && (
            <TabButtons>
              <TabButtons.Tab onClick={() => setActivePeriod('quarterly')} active={activePeriod === 'quarterly'}>Quarterly</TabButtons.Tab>
              <TabButtons.Tab onClick={() => setActivePeriod('annual')} active={activePeriod === 'annual'}>Annual</TabButtons.Tab>
            </TabButtons>
          )}
        </div>
      )}

      <div className={style.flexContainer}>
        {activeTab === 'income' ?
          <>
            <div className={style.chart}>
              <IncomeStatementChart stock={stock} period={activePeriod} />
            </div>
            {!hideDetails &&
              <div>
                <IncomeStatementTable stock={stock} period={activePeriod} />
              </div>
            }
          </>
          :
          <>
            <div className={style.chart}>
              <BalanceSheetChart stock={stock} />
            </div>
            {!hideDetails &&
              <div>
                <BalanceSheetTable stock={stock} />
              </div>
            }
          </>
        }
      </div>
    </div>
  );
};

export default StockDetails;
